<mat-dialog-content xmlns="http://www.w3.org/1999/html">
  <h2>{{"admin.countries.create" | translate}} {{"admin.weee-system.weee-system" | translate}}</h2>
  <mat-card-content>
    <form (submit)="sendCreationRequest()" [formGroup]="weeeSystemCreateForm" autocomplete="off">
      <div class="form-container">
        <mat-form-field appearance="fill">
          <mat-label>{{"admin.dialogs.description" |translate}}</mat-label>
          <input [formControl]="descriptionControl" matInput type="text">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{"admin.countries.country" | translate}}</mat-label>
          <mat-select [formControl]="countryControl">
            <mat-option *ngFor="let country of data" [value]="country">{{country.name}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-checkbox [formControl]="memberControl">{{"admin.weee-system.member" | translate}}</mat-checkbox>

        <div class="edit-dialog-buttons-container">
          <button mat-raised-button (click)="closeDialog()" type="button" >
            <span>Close</span>
          </button>
          <button [disabled]="weeeSystemCreateForm.invalid" mat-raised-button color="primary" type="submit">
            <span>Save</span>
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-dialog-content>
